import { Prompt } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import VideoSection from './VideoSection/VideoSection';
import RightPanel from './RightPanel/RightPanel';
import AppLayout from '../../components/AppLayout';
import useGroupVideoCallFunctions from './useGroupVideoCallFunctions';
import MediaError from './MediaError';
import StartMeeting from './StartMeeting';
import InviteParticipantsModal from './VideoSection/InviteParticipantsModal';

const GroupVideoCallScreen = ({ socket }) => {
  const { t } = useTranslation();
  const {
    history,
    params,
    currentUser,
    callStarted,
    setCallStarted,
    rightPanelOpen,
    setRightPanelOpen,
    rightPanelTab,
    setRightPanelTab,
    callSeconds,
    showInviteModal,
    setShowInviteModal,
    peers,
    localStream,
    micOn,
    videoOn,
    screenShareActive,
    copySuccess,
    setCopySuccess,
    mediaError,
    sharedFiles,
    chatMessages,
    roomId,
    handleToggleMic,
    handleToggleVideo,
    handleScreenShare,
    handleLeaveCall,
    handleSendChatMessage,
    handleShareFile,
    getRoomLink,
    handleCopyLink,
    handlePanelTabClick,
  } = useGroupVideoCallFunctions({ socket });

  if (mediaError) {
    return <MediaError history={history} mediaError={mediaError} />;
  }

  if (!callStarted) {
    return <StartMeeting roomId={roomId} setCallStarted={setCallStarted} copySuccess={copySuccess} setCopySuccess={setCopySuccess} />;
  }

  const peerNames = peers.map(p => p.name);
  const peerObjects = peers.map(p => p.peer);

  return (
    <AppLayout>
      <Prompt when={callStarted} message={t('screens.video.group.leaveWarn')} />
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
        <Header headerTitle={t('screens.video.group.headerTitle')} callSeconds={callSeconds} participantCount={peers.length + 1} onInvite={() => setShowInviteModal(true)} />
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden', position: 'relative' }}>
          <VideoSection rightPanelOpen={rightPanelOpen} peers={peerObjects} peerNames={peerNames} localStream={localStream} videoOn={videoOn} />
          <RightPanel
            open={rightPanelOpen}
            activeTab={rightPanelTab}
            onTabChange={setRightPanelTab}
            onClose={() => setRightPanelOpen(false)}
            roomId={params.roomId || roomId}
            currentUserId={currentUser?._id}
            peers={peerObjects}
            peerNames={peerNames}
            currentUser={currentUser}
            sharedFiles={sharedFiles}
            onShareFile={handleShareFile}
            chatMessages={chatMessages}
            onSendChatMessage={handleSendChatMessage}
          />
        </div>
        <Footer
          onAddParticipants={() => setShowInviteModal(true)}
          onScreenShare={handleScreenShare}
          screenShare={screenShareActive}
          onLeaveCall={handleLeaveCall}
          onToggleMic={handleToggleMic}
          onToggleVideo={handleToggleVideo}
          micOn={micOn}
          videoOn={videoOn}
          onPanelTabClick={handlePanelTabClick}
          rightPanelOpen={rightPanelOpen}
          rightPanelTab={rightPanelTab}
        />
      </div>

      {/* Invite Participants Modal */}
      {showInviteModal && (
        <InviteParticipantsModal getRoomLink={getRoomLink} setShowInviteModal={setShowInviteModal} handleCopyLink={handleCopyLink} copySuccess={copySuccess} />
      )}
    </AppLayout>
  );
};

export default GroupVideoCallScreen;
